import { type FC } from "react";

import { Upload, UserPlus, CirclePlus, MessageCircleQuestion } from "lucide-react";
import { useNavigate } from "react-router-dom";
import type { LucideIcon } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { POST_LOSS_ROUTES } from "@/shared/constants/paths";

interface QuickAction {
  label: string;
  icon: LucideIcon;
  action: () => void;
}

interface QuickActionsWidgetProps {
  className?: string;
}

export const QuickActionsWidget: FC<QuickActionsWidgetProps> = ({ className }) => {
  const navigate = useNavigate();

  const actions: QuickAction[] = [
    {
      label: "Upload a document",
      icon: Upload,
      action: () => navigate(`${POST_LOSS_ROUTES.DOCUMENTS}?upload=true`),
    },
    {
      label: "Invite someone to help",
      icon: UserPlus,
      action: () => navigate(POST_LOSS_ROUTES.CONTACTS),
    },
    {
      label: "Add an account or property",
      icon: CirclePlus,
      action: () => navigate(POST_LOSS_ROUTES.ESTATE_INVENTORY),
    },
    {
      label: "Ask a question",
      icon: MessageCircleQuestion,
      action: () => window.Intercom?.("show"),
    },
  ];

  return (
    <div
      className={`flex flex-col gap-6 border border-primary rounded-lg bg-white p-6 ${className ?? ""}`}
    >
      <p className="text-base font-semibold tracking-[-0.02em]">Quick actions</p>
      <div className="flex flex-col gap-4">
        {actions.map((action) => (
          <Button
            key={action.label}
            variant="link"
            onClick={action.action}
            className="justify-start gap-3 font-normal text-secondary tracking-[-0.02em]"
          >
            <action.icon className="size-4 shrink-0" />
            {action.label}
          </Button>
        ))}
      </div>
    </div>
  );
};
